const UserActionType = {
	SET_USERS: "SET_USERS",
	FETCH_USERS: "FETCH_USERS",
};

export default UserActionType;